import Vue from 'vue';
const cacheMap: any = {};

function createInstance(component:any, options?:any, name?:any) {
  if (cacheMap[name]) {
    return cacheMap[name];
  }
  // if (componentsMap[componentName]) {
  //     return componentsMap[componentName];
  // }
  const vueObj = new Vue({
    render(h) {
      return h(component, { props: (this as any).data });
    },
    data() {
      return {
        data: options,
      };
    },
  });

  vueObj.$mount(document.createElement('div'));
  document.body.appendChild(vueObj.$el);
  if (name) {
    // eslint-disable-next-line prefer-destructuring
    cacheMap[name] = vueObj.$children[0];
  }
  return vueObj.$children[0];
}

export default createInstance;
